import { createProductId } from '@domain/value-objects';
import type { Unbrand } from '@shared/value-objects/brand';
import { optVO, reqRecord, reqVO } from '@shared/value-objects/parse-helpers';
import { createUrl } from '@shared/value-objects';
import type { Product } from './model';

/// API の生レスポンス (`unknown`) を検証して branded な `Product` にする門番 (parse, don't validate / #471)。
/// 失敗方針: 必須 id・present かつ不正な任意フィールドは throw、任意の値なしは null、`raw` 値はログに載せない。

export function parseProduct(raw: unknown): Product {
  reqRecord(raw, 'product');
  const dto = raw as Unbrand<Product>;
  return {
    ...dto,
    id: reqVO(dto.id, createProductId, 'product.id'),
    representative_sales_material_url: optVO(
      dto.representative_sales_material_url,
      createUrl,
      'product.representative_sales_material_url',
    ),
    service_site_url: optVO(dto.service_site_url, createUrl, 'product.service_site_url'),
  };
}
